var lazySnail = function(selektor, options) {
  var $this = this
  this.target = $(selektor)
  if (options.whereToAppendMoreLink) {
    options.whereToAppendMoreLink = $(options.whereToAppendMoreLink)
  }
  this.defaults = {
    itemStartCount: 10,
    type: 'onClick',
    scrollOffset: 0,
    whereToAppendMoreLink: this.target.parent(),
    moreLink: '<a class="showMoreArticles" href="#">ROZWIŃ STARSZE ARTYKUŁY</a>',
    numberOfRevealedItems: 4,
    method: 'background-image'
  }
  for (var index in options) {
    this.defaults[index] = options[index]
  }
  this.HideToMuchItems = function() {
    $this.target.hide()
    var counter = 1
    $this.target.each(function() {
      if (counter <= $this.defaults.itemStartCount) {
        $(this).show()
        if ($(this).data('bg') != undefined) {
          var bgItem = $(this)
        } else {
          var bgItem = $(this).find('[data-bg]')
        }
        bgItem.css('background-image', 'url("' + bgItem.data('bg') + '")')
      }
      counter++
    })
  }
  this.appendMoreLink = function() {
    if ($this.defaults.type == 'onClick') {
      if ($this.target.length > $this.defaults.itemStartCount) {
        $this.defaults.whereToAppendMoreLink.append('<div class="showMoreWrap">' + $this.defaults.moreLink + '</div>')
      }
    } else {
      if ($this.target.length > $this.defaults.itemStartCount) {
        $this.defaults.whereToAppendMoreLink.append('<div class="showMoreWrap"></div>')
      }
    }
  }
  this.engine = function() {
    if ($this.defaults.type == 'onScroll') {
      var trigger = 1
      $(window).scroll(function() {
        var starter = $('.showMoreWrap').offset().top
        var scrollTop = $(this).scrollTop()
        var windowHeight = $(this).height()
        var startPosition = scrollTop + windowHeight - $this.defaults.scrollOffset
        if (startPosition > starter) {
          if (trigger) {
            trigger = 0
            $('.showMoreWrap').html($this.defaults.moreLink)
            var counter = 1
            $this.target.each(function() {
              if (!$(this).is(':visible') && counter <= $this.defaults.numberOfRevealedItems) {
                $(this).addClass('lazySnailOperating')
                if ($(this).data('bg') != undefined) {
                  var bgItem = $(this)
                } else {
                  var bgItem = $(this).find('[data-bg]')
                }
                if ($this.defaults.method == 'background-image') {
                  bgItem.css('background-image', 'url("' + bgItem.data('bg') + '")')
                } else if ($this.defaults.method == 'img-src') {
                  bgItem.attr('src', bgItem.data('bg'))
                } else {
                  console.log('zła metoda')
                  console.log('dostępne metody:')
                  console.log('background-image')
                  console.log('img-src')
                }
                counter++
              }
            })
            if ($('.lazySnailOperating').data('bg') != undefined) {
              var item = $('.lazySnailOperating')
            } else {
              var item = $('.lazySnailOperating').find('[data-bg]')
            }
            if ($this.defaults.method == 'background-image') {
              item.imagesLoaded({ background: true }, function() {
                $('.lazySnailOperating').slideDown()
                $('.lazySnailOperating').removeClass('lazySnailOperating')
                $('.showMoreWrap').html('')
                setTimeout(function() {
                  trigger = 1
                }, 1000)
              })
            } else if ($this.defaults.method == 'img-src') {
              item.imagesLoaded(function() {
                $('.lazySnailOperating').slideDown()
                $('.lazySnailOperating').removeClass('lazySnailOperating')
                $('.showMoreWrap').html('')
                setTimeout(function() {
                  trigger = 1
                }, 1000)
              })
            }
          }
        }
      })
    } else {
      $this.defaults.whereToAppendMoreLink.find('.showMoreArticles').click(function(e) {
        e.preventDefault()
        var counter = 1
        $this.target.each(function() {
          if (!$(this).is(':visible') && counter <= $this.defaults.numberOfRevealedItems) {
            $(this).slideDown(800)
            if ($(this).data('bg') != undefined) {
              var bgItem = $(this)
            } else {
              var bgItem = $(this).find('[data-bg]')
            }
            if ($this.defaults.method == 'background-image') {
              bgItem.css('background-image', 'url("' + bgItem.data('bg') + '")')
            } else if ($this.defaults.method == 'img-src') {
              bgItem.attr('src', bgItem.data('bg'))
            } else {
              console.log('zła metoda')
              console.log('dostępne metody:')
              console.log('background-image')
              console.log('img-src')
            }
            if ($(this).index() + 1 == $this.target.length) {
              $('.showMoreWrap').fadeOut()
            }
            counter++
          }
        })
      })
    }
  }
  this.HideToMuchItems()
  this.appendMoreLink()
  this.engine()
}
var faqTabs = function(parentWrap, czasAnimacji) {
  var thi$ = this
  thi$.faqEr = function() {
    $(parentWrap + ' .faqLabel').click(function(e) {
      e.preventDefault()
      var content = $(this)
        .parents('.faqWrap')
        .find('.faqContent')
      if (!content.is(':visible')) {
        $(parentWrap + ' .faqLabel').removeClass('faqActive')
        $(parentWrap + ' .faqContent').slideUp(czasAnimacji)
        $(this).addClass('faqActive')
        content.slideDown(czasAnimacji)
      } else {
        $(parentWrap + ' .faqLabel').removeClass('faqActive')
        $(parentWrap + ' .faqContent').slideUp(czasAnimacji)
      }
    })
  }
  thi$.hider = function() {
    $(parentWrap + ' .faqContent').hide()
  }
  thi$.hider()
  thi$.faqEr()
}
export default function(distanceOffset) {
  var thi$ = this
  thi$.distance = distanceOffset
  thi$.catchUrl = function() {
    let href = ''
    href = window.location.hash
    href = href.replace(/^#(.*)/g, '$1')
    if (href != '') {
      $(window).on('load', function() {
        thi$.mechanism(href)
      })
    }
  }
  thi$.mechanism = function(selktor) {
    if ($(selktor).length > 1) {
      console.log('UPS!!, liczba elementów większa niż jeden, nie wiem do którego zescrollować, musisz wskazać na jeden element')
    } else if ($(selktor).length == 0) {
      console.log('UPS!!, nie mogę znaleźć elementu do którego mam zescrollować')
    } else {
      var offset = 0
      if (thi$.distance !== undefined) {
        offset = thi$.distance
      }
      var computer = $('html, body')
      var topPosition = $(selktor).offset().top
      topPosition = topPosition - offset
      computer.stop(true, false)
      computer.animate({ scrollTop: topPosition }, 1500, 'swing')
    }
  }
  $('a[data-target]').click(function(e) {
    e.preventDefault()
    var target = $(this).data('target')
    if ($('#menu .toggle').hasClass('clicked')) {
      $('#menu .toggle').trigger('click')
    }
    thi$.mechanism(target)
  })
  thi$.catchUrl()
}
